import React from 'react';
import PageHeader from '../../../page-header';
import { MainFrameContext } from '../../index';
import Crumb from '../Crumb';
const MainPageHeader = (props) => {
    const { prefixCls, crumbData } = React.useContext(MainFrameContext);
    const dom = React.createElement(Crumb, { data: crumbData !== null && crumbData !== void 0 ? crumbData : [] });
    if (!crumbData || (crumbData === null || crumbData === void 0 ? void 0 : crumbData.length) <= 1) {
        return null;
    }
    return (React.createElement(PageHeader, Object.assign({ className: `${prefixCls}-page-header`, breadcrumb: dom }, props)));
};
export default MainPageHeader;
